import {Component, Input} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

export interface DialogAlertData {
  message: string;
  color: string;
  icon?: string,
  title?: string,
  titleOriginal?: string,
  disableClose?: boolean;
  btnCloseName?: string;
  btnOtherName?: string;
  btnOtherBg?: string;
}

@Component({
  standalone: false,
  selector: 'app-c-confirm-dialog',
  template: `
      <ng-container *transloco="let t">
        <div class="modal-header py-2 bg-light">
          <h5 class="modal-title">
            <i class="ph {{ data.icon ? data.icon : 'ph-warning' }} me-2"></i>
            {{ data.titleOriginal ? data.titleOriginal : t(data.title ? data.title : 'common.notification') }}
          </h5>
          @if (!data.disableClose) {
            <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
          }
        </div>
        <div class="modal-body">
          <div class="alert alert-{{ data.color ?  data.color : 'warning' }} mb-0"
            [innerHTML]="data.message">
          </div>
      
          @if (data.btnOtherName) {
            <div class="d-flex justify-content-end mt-3">
              <button type="button" class="btn btn-sm {{data.btnOtherBg ? data.btnOtherBg : 'btn-primary'}} me-2"
                (click)="onOther()">
                {{ t(data.btnOtherName) }}
              </button>
            </div>
          }
        </div>
      </ng-container>
      `,
})
export class AlertDialogComponent {
  @Input() data!: DialogAlertData;

  constructor(public activeModal: NgbActiveModal) {
  }

  onClose() {
    this.activeModal.dismiss({
      buttonName: 'btnClose'
    })
  }

  onOther() {
    this.activeModal.dismiss({
      buttonName: 'buttonOther'
    })
  }
}
